<script>
	import Item from './lib/Item.svelte';

	export let buttonLabel = '';

	export let news = [];

	const list = news.slice(0, 3);

	function showMore() {
	    window.location.href = 'https://www.ubinam.de/#';
	}
</script>

<div class="item-list">
	{#if !list.length}
		Nothing to show... 
	{:else}
		{#each list as el}
			{#if el && el.imgURL && el.title && el.description && el.linkURL}
				<Item 
					imgURL={el.imgURL} 
					title={el.title} 
					description={el.description}
					linkURL={el.linkURL}
				/>
			{/if}
		{/each}
		<div class="button-container">
			<button data-i18n="login.news.more" class="btn btn-primary link" on:click={showMore}>{buttonLabel}</button>
		</div>
	{/if}
</div>

<style lang="scss">
	@import './global.scss';

	@media screen and (max-width: 768px) {
		.item-list {
			margin: 0 2rem 0 -1.5rem;
		}
		button {
			width: 100%;
		}
	}
	@media screen and (min-width: 768px) {
		.item-list {
			margin: 0 5rem;
		}
		button {
			width: 35%;
		}
	}
	.button-container {
		text-align: right;
		width: 100%;
		margin: 2rem;
	}
	button {
		text-align: center;
		margin: 1rem 0;
	}
</style>